import { getAPIPath, requestGooseAPI } from '../shared/request'
import { CLIENT_VOUCHERS_PATH, VoucherClientDto, APIVoucherClientDtoResponse } from '../types'

const MAX_BATCH_SIZE = 200

export type VoucherFilterParams = {
  locationUserProfile?: string | null
  locationServiceType?: string | null
  serviceType?: string | null
  limit?: number
  isUsed?: boolean | null
  usedAt?: Date | string | null
  expired?: boolean | null
  expiredAt?: Date | string | null
  nextToken?: string | null
  displayName?: string | null
  sourceDisplayName?: string | null
  sortOrder?: string | null
  type?: 'OFFER' | 'CASH'
  atLeastOneAvailable?: boolean
  includes?: string[]
  createdAt?: Date | string | null
  includeShared?: boolean
  invoiceItemId?: string | null
}

export const ClientVoucherService = {
  listCredit: async (locationName: string, filters: VoucherFilterParams = {}): Promise<VoucherClientDto[]> => {
    const result: VoucherClientDto[] = []
    const { limit = MAX_BATCH_SIZE, ...rest } = filters
    let nextToken: string | null = ''
    while (nextToken !== null) {
      const batchRes: APIVoucherClientDtoResponse = await requestGooseAPI<APIVoucherClientDtoResponse>({
        url: getAPIPath(CLIENT_VOUCHERS_PATH, { locationId: locationName }),
        method: 'GET',
        params: {
          limit,
          nextToken: nextToken === '' ? undefined : nextToken,
          ...rest,
        },
      })
      result.push(...batchRes.results)
      nextToken = limit < MAX_BATCH_SIZE ? null : batchRes.nextToken
    }

    return result
  },
}
